export type CoreBrand = {
    id: number;
    idTenant: number;
    name: string;
    guid: string;

    isDeleted: boolean;
    isDisabled: boolean;
};

export type CoreTenant = {
    id: number;
    name: string;
    guid: string;
    dbName: string;

    isDeleted: boolean;
    isDisabled: boolean;
};

export type CoreType = {
    id: number;
    idBrand: number;
    name: string;
    idFieldExternID: number | null;
    idParentType: number | null;
    guid: string;
    dbName: string;
    dbFrom: string;

    isDeleted: boolean;
    isDisabled: boolean;
};

export type CoreField = {
    id: number;
    idBrand: number;
    name: string;
    idType: number;
    idLookupType: number | null;
    dataType: CoreDataPointDataType;
    isPHI: boolean;
    guid: string;
    dbName: string;

    isDeleted: boolean;
    isDisabled: boolean;
};

export enum CoreDataPointDataType {
    Integer = 1,
    Float = 2,
    String = 3,
    DateTime = 4,
    Binary = 5,
    Lookup = 6,
    NOTUSED = 7,
    Autonumber = 8,
    Phonenumber = 9,
    Date = 10,
    TenantTrackable = 11
};

export type CoreDataPoint = {
    id: number;
    idBrand: number;
    name: string;
    idType: number;
    idField: number;
    idLookupType: number | null;
    dataType: CoreDataPointDataType;
    isPHI: boolean;
    guid: string;
    dbName: string;

    sort: number;
    filter: string;

    isAdded: boolean;
    isUpdated: boolean;
};
